import type { SVGProps } from "react";

export default function IconXls(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 170 170" {...props}>
      <g transform="matrix(0.26458333,0,0,0.26458333,-528.89159,-846.02794)">
        <circle
          transform="matrix(0.9871,-0.1602,0.1602,0.9871,-559.5748,388.1709)"
          fill="#2bb673"
          cx="2127.876"
          cy="3664.897"
          id="ellipse190"
          r="34.041"
        />

        <path
          d="m 2127.877,3705.438 c -22.354,0 -40.541,-18.187 -40.541,-40.541 0,-22.354 18.187,-40.541 40.541,-40.541 22.354,0 40.54,18.187 40.54,40.541 0,22.354 -18.187,40.541 -40.54,40.541 z m 0,-68.082 c -15.187,0 -27.541,12.354 -27.541,27.541 0,15.187 12.354,27.541 27.541,27.541 15.186,0 27.54,-12.354 27.54,-27.541 0,-15.187 -12.354,-27.541 -27.54,-27.541 z"
          id="path190"
        />

        <path
          fill="#ffffff"
          d="m 2377.707,3243.484 h -165.633 c -45.206,0 -81.852,36.646 -81.852,81.852 v 392.66 c 0,45.206 36.646,81.852 81.852,81.852 h 236.296 c 45.205,0 81.852,-36.646 81.852,-81.852 V 3396 Z"
          id="path191"
        />

        <path
          d="m 2448.37,3806.348 h -236.296 c -48.717,0 -88.352,-39.635 -88.352,-88.352 v -392.66 c 0,-48.717 39.635,-88.352 88.352,-88.352 h 165.633 c 1.724,0 3.377,0.685 4.597,1.903 l 152.515,152.517 c 1.22,1.219 1.904,2.872 1.904,4.596 v 321.996 c 0,48.717 -39.635,88.352 -88.353,88.352 z m -236.296,-556.364 c -41.549,0 -75.352,33.803 -75.352,75.352 v 392.66 c 0,41.549 33.803,75.352 75.352,75.352 h 236.296 c 41.55,0 75.353,-33.803 75.353,-75.352 v -319.304 l -148.708,-148.708 z"
          id="path192"
        />

        <path
          fill="#dcddde"
          d="M 2377.707,3243.484 2530.222,3396 h -119.99 c -17.963,0 -32.525,-14.562 -32.525,-32.525 z"
          id="path193"
        />

        <path
          d="m 2530.242,3402.5 c 0,0 -0.012,0 -0.02,0 h -119.99 c -21.519,0 -39.025,-17.507 -39.025,-39.025 v -119.99 c 0,-2.629 1.584,-4.999 4.013,-6.005 2.427,-1.005 5.224,-0.451 7.083,1.409 l 152.222,152.221 c 1.36,1.191 2.218,2.94 2.218,4.891 -10e-4,3.589 -2.91,6.499 -6.501,6.499 z m -146.035,-143.323 v 104.298 c 0,14.351 11.675,26.025 26.025,26.025 h 104.298 z"
          id="path194"
        />

        <path
          fill="#2bb673"
          d="m 2130.971,3468.603 c -20.219,0 -36.61,16.391 -36.61,36.61 v 153.307 h 0.671 c 3.256,-16.885 18.104,-29.641 35.939,-29.641 h 368.678 v -160.276 z"
          id="path195"
        />

        <path
          d="m 2095.032,3665.02 h -0.671 c -3.59,0 -6.5,-2.91 -6.5,-6.5 v -153.307 c 0,-23.771 19.339,-43.11 43.11,-43.11 h 368.677 c 3.59,0 6.5,2.91 6.5,6.5 v 160.276 c 0,3.59 -2.91,6.5 -6.5,6.5 h -368.677 c -14.404,0 -26.835,10.249 -29.557,24.371 -0.589,3.059 -3.267,5.27 -6.382,5.27 z m 35.94,-189.917 c -16.603,0 -30.11,13.508 -30.11,30.11 v 129.438 c 7.839,-7.641 18.529,-12.271 30.11,-12.271 h 362.177 v -147.276 h -362.177 z"
          id="path196"
        />

        <path
          fill="#ffffff"
          d="m 2195.142,3583.886 28.804,-36.559 -27.327,-34.466 c -0.861,-1.107 -1.6,-2.216 -1.6,-3.692 0,-2.462 2.092,-4.678 4.8,-4.678 1.97,0 3.078,0.984 4.309,2.462 l 25.973,33.728 25.604,-33.358 c 1.354,-1.601 2.585,-2.831 4.677,-2.831 2.339,0 4.432,1.97 4.432,4.555 0,1.23 -0.492,2.462 -1.354,3.446 l -27.45,34.712 28.435,36.313 c 0.984,1.107 1.601,2.216 1.601,3.569 0,2.585 -2.093,4.801 -4.801,4.801 -1.97,0 -3.077,-0.984 -4.309,-2.462 l -27.203,-35.327 -26.834,34.958 c -1.354,1.601 -2.585,2.831 -4.801,2.831 -2.216,0 -4.309,-1.97 -4.309,-4.555 0,-1.231 0.49,-2.462 1.353,-3.447 z"
          id="path197"
        />

        <path
          fill="#ffffff"
          d="m 2286.357,3509.415 c 0,-2.708 2.215,-4.924 4.8,-4.924 2.708,0 4.924,2.216 4.924,4.924 v 72.871 h 44.683 c 2.462,0 4.432,2.092 4.432,4.554 0,2.462 -1.97,4.432 -4.432,4.432 h -49.606 c -2.585,0 -4.8,-2.216 -4.8,-4.924 v -76.933 z"
          id="path198"
        />

        <path
          fill="#ffffff"
          d="m 2359.477,3580.932 c -1.107,-0.738 -1.846,-2.093 -1.846,-3.692 0,-2.708 2.093,-4.801 4.678,-4.801 1.23,0 2.338,0.492 2.954,1.107 8.124,6.894 16.248,10.217 27.203,10.217 11.57,0 19.202,-6.154 19.202,-14.647 v -0.247 c 0,-8.001 -4.308,-12.555 -22.402,-16.371 -19.818,-4.308 -28.927,-10.709 -28.927,-24.864 v -0.246 c 0,-13.54 11.939,-23.511 28.312,-23.511 11.324,0 19.571,2.831 27.449,8.493 0.984,0.738 2.093,2.093 2.093,3.938 0,2.585 -2.093,4.678 -4.678,4.678 -1.107,0 -1.97,-0.246 -2.831,-0.861 -7.263,-5.293 -14.278,-7.509 -22.28,-7.509 -11.201,0 -18.341,6.154 -18.341,13.909 v 0.246 c 0,8.125 4.432,12.679 23.388,16.741 19.203,4.185 28.065,11.201 28.065,24.372 v 0.246 c 0,14.771 -12.31,24.372 -29.419,24.372 -12.556,0 -23.019,-3.939 -32.62,-11.57 z"
          id="path199"
        />
      </g>
    </svg>
  );
}
